import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { ButtonIwText } from '@/_pages/interwill/components/ButtonIwText';
import { media } from '@/shared/components';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { VideoRecordNextModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const VideoRecordNextModal: FC<VideoRecordNextModalProps> = ({
  role,
  name,
  onNext,
  onBack,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'videoRecordNext' });
  const modals = useModalsStore();

  return (
    <ModalContainerV2
      pinBottom
      title={t('title', {
        role,
        name,
      })}
      closable={false}
    >
      <InnerForm>
        <span>{t('text')}</span>
      </InnerForm>
      <Buttons>
        <ButtonIwText
          onClick={() => {
            modals.closeModal();
            onBack();
          }}
          type="default"
        >
          {t('backBtn')}
        </ButtonIwText>
        <ButtonIw
          onClick={() => {
            onNext();
            modals.closeModal();
            modals.openModal({
              type: 'RecordingModal',
            });
          }}
        >
          {t('startBtn')}
        </ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 24px 0;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;
